import SettingsPhoneNumbers from '../components/settings/SettingsPhoneNumbers';
import SettingsMessages from '../components/settings/SettingsMessages';
import SettingsUserRoles from '../components/settings/UserRoles/SettingsUserRoles';
import SettingsUserRolesCreate from '../components/settings/UserRoles/SettingsUserRolesCreate';
import SettingsUserRolesEdit from '../components/settings/UserRoles/SettingsUserRolesEdit';
import SettingsPaymentGateways from '../components/settings/SettingsPaymentGateways';
import SettingsMoverMessages from '../components/settings/SettingsMoverMessages';
import SettingsClaimTypesList from '../components/settings/ClaimTypes/SettingsClaimTypesList';
import SettingsEditClaimType from '../components/settings/ClaimTypes/SettingsEditClaimType';
import FilterTemplates from '../components/settings/FilterTemplates/FilterTemplates';
import Tags from '../components/settings/Tags/Tags';

/* MAILING */
import SmtpServers from '../components/settings/Mailing/SmtpServers';
import FollowUpTemplates from '../components/settings/Mailing/FollowUpTemplates';
import ClaimEmailTemplates from '../components/settings/Mailing/ClaimEmailTemplates';
import AcknowledgmentEmailTemplates from '../components/settings/Mailing/AcknowledgmentEmailTemplates';
import SettlementEmailTemplates from '../components/settings/Mailing/SettlementEmailTemplates';
import EmailTemplates from '../components/settings/Mailing/EmailTemplates';

const Template = {
  template: '<router-view></router-view>',
};

export default {
  path: '/settings',
  component: Template,
  children: [
    {
      path: 'smtp-servers',
      name: 'SmtpServers',
      component: SmtpServers,
      meta: {
        title: 'Smtp servers - Mod24',
      },
    },
    {
      path: 'follow-up-templates',
      name: 'SettingsFollowUpTemplates',
      component: FollowUpTemplates,
      meta: {
        title: 'Followup Templates - Mod24',
      },
    },
    {
      path: 'email-templates',
      name: 'SettingsEmailTemplates',
      component: EmailTemplates,
      meta: {
        title: 'Email Templates - Mod24',
      },
    },
    // {
    //   path: 'domains',
    //   name: 'SettingsCompanyDomains',
    //   component: CompanyDomains,
    //   meta: {
    //     title: 'Company Domains - Mod24',
    //   },
    // },
    {
      path: 'claim-templates',
      name: 'SettingsClaimEmailTemplates',
      component: ClaimEmailTemplates,
      meta: {
        title: 'Claim Templates - Mod24',
      },
    },
    {
      path: 'acknowledgement-templates',
      name: 'SettingsAcknowledgmentEmailTemplates',
      component: AcknowledgmentEmailTemplates,
      meta: {
        title: 'Acknowledgement Templates - Mod24',
      },
    },
    {
      path: 'settlement-templates',
      name: 'SettingsSettlementEmailTemplates',
      component: SettlementEmailTemplates,
      meta: {
        title: 'Settlement Templates - Mod24',
      },
    },
    {
      path: 'phone-numbers',
      name: 'SettingsPhoneNumbers',
      component: SettingsPhoneNumbers,
      meta: {
        title: 'Phone Numbers - Mod24',
      },
    },
    {
      path: 'messages',
      name: 'SettingsMessages',
      component: SettingsMessages,
      meta: {
        title: 'Messages - Mod24',
      },
    },
    {
      path: 'mover-messages',
      name: 'SettingsMoverMessages',
      component: SettingsMoverMessages,
      meta: {
        title: 'Messages - Mod24',
      },
    },
    {
      path: 'tags',
      name: 'Tags',
      component: Tags,
      meta: {
        title: 'Tags - Mod24',
      },
    },
    {
      path: 'filters',
      name: 'FilterTemplates',
      component: FilterTemplates,
      meta: {
        title: 'Filters - Mod24',
      },
    },
    {
      path: 'user-roles',
      component: Template,
      children: [
        {
          path: '',
          name: 'SettingsUserRoles',
          component: SettingsUserRoles,
          meta: {
            title: 'Roles - Mod24',
          },
        },
        {
          path: 'create',
          name: 'SettingsUserRolesCreate',
          component: SettingsUserRolesCreate,
          meta: {
            title: 'Create Role - Mod24',
          },
        },
        {
          path: 'edit/:id',
          name: 'SettingsUserRolesEdit',
          component: SettingsUserRolesEdit,
          meta: {
            title: 'Edit Role - Mod24',
          },
        },
      ],
    },
    {
      path: 'claim-types',
      component: Template,
      children: [
        {
          path: '',
          name: 'SettingsClaimTypes',
          component: SettingsClaimTypesList,
          meta: {
            title: 'Claim Types - Mod24',
          },
        },
        {
          path: 'edit/:id',
          name: 'SettingsEditClaimType',
          component: SettingsEditClaimType,
          meta: {
            title: 'Edit Claim Type - Mod24',
          },
        },
      ],
    },
    {
      path: 'payment-gateways',
      name: 'SettingsPaymentGateways',
      component: SettingsPaymentGateways,
      meta: {
        title: 'Payment Gateways - Mod24',
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/settingsRoutes.js